import React from "react";
function Cancel() {
  return <h1>Your Payment has been Canceled. Please try order again</h1>;
}

export default Cancel;
